import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { SnackbarProvider, useSnackbar } from "notistack";
import makeStyles from "@mui/styles/makeStyles";
import {
  Modal,
  Typography,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Box,
} from "@mui/material";
import ButtonBlue from "../../shared/buttonBlue";
import SiteService from "../../../../services/site.service";
import { getAllVehicles } from "../../../../actions/vehicle";
import { getLocationAndVehicleUsage } from "../../../../actions/locationVehicle";

const useStyles = makeStyles((theme) => ({
  Modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    width: "250px",
    height: "150px",
  },
  Paper: {
    width: "500px",
    padding: "20px",
    boxShadow: 24,
  },
  Select: {
    width: "100%",
  },
  partOfTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  IconCar: {
    fontSize: "40px",
    marginRight: "10px",
    color: theme.palette.primary.main,
  },
  Title: {
    fontSize: "30px",
    color: theme.palette.primary.main,
  },
  Text: {
    fontSize: "15px",
  },
  partOfTitleName: {
    display: "flex",
    alignItems: "center",
  },

  partOfNavSwitch: {
    display: "flex",
    alignItems: "center",
  },
  partOfNavButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const CarConnectionModal = ({ open, onClose, userId, lat, lng }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const driverProfile = useSelector((state) => state.driverItem);
  const locationDriver = useSelector(
    (state) => state.locationVehicle
  );
  const AllVehicles = useSelector((state) => state.vehicles);
  const [filteredTypeVehicle, setFilteredVehicleType] = useState([]);
  const [currentVehicle, setCurrentVehicle] = useState(null);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  useEffect(() => {
    if (!AllVehicles.result) dispatch(getAllVehicles());
  }, [dispatch]);

  useEffect(() => {
    if (driverProfile.result?.serviceType) {
      setFilteredVehicleType(
        (AllVehicles.result || []).filter(
          (vehicle) => vehicle.ServiceType === driverProfile.result.serviceType
          // || vehicle.ServiceType === null
        )
      );
    }
  }, [driverProfile.result, AllVehicles.result]);

  const handleVehicleChange = (event) => {
    const selectedId = event.target.value;
    const vehicle = filteredTypeVehicle.find((v) => v.idVehicle === selectedId);
    setSelectedVehicle(vehicle);
  };

  useEffect(() => {
    setSelectedVehicle(null);
    if (
      locationDriver.result &&
      locationDriver.result.length > 0 &&
      !locationDriver.result[0].endTime
    ) {
      const foundVehicle = filteredTypeVehicle.find(
        (vehicle) => vehicle.idVehicle === locationDriver.result[0].idVehicle
      );
      setCurrentVehicle(foundVehicle || null);
    }
  }, [open]);

  const {
    register,
    handleSubmit,
    control,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const selectedVehicleId = watch("idVehicle", "");

  const onClickYes = () => {
    const endTime = new Date().toISOString();

    SiteService.setDeliverySampleLocationDriverByIdUsage({
      idUsage: locationDriver.result[0].idUsage,
      endTime: endTime,
    }).then((res) => {
      if (res.data) {
        enqueueSnackbar("สิ้นสุดการใช้งานรถรับส่งตัวอย่างสำเร็จ", {
          variant: "success",
        });
        dispatch(getLocationAndVehicleUsage(userId));
        setTriggerUpdate((prev) => !prev);
      } else {
        enqueueSnackbar("สิ้นสุดการใช้งานรถรับส่งตัวอย่างล้มเหลว", {
          variant: "error",
        });
      }
    });
  };

  useEffect(() => {}, [triggerUpdate]);

  const onClickSubmit = (AnswerFromInput) => {
    const startTime = new Date().toISOString();

    SiteService.addDeliverySampleLocationDriver({
      idVehicle: AnswerFromInput.idVehicle,
      startTime: startTime,
      idDriver: userId,
    }).then((res) => {
      if (res.data) {
        dispatch(getLocationAndVehicleUsage(userId));
        onClose();
        enqueueSnackbar("บันทึกข้อมูลสำเร็จ", { variant: "success" });
      } else {
        enqueueSnackbar("บันทึกข้อมูลล้มเหลว", { variant: "error" });
      }
    });
  };

  return (
    <Modal
      className={`${classes.Modal}`}
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Paper className={`${classes.Paper}`}>
        {locationDriver.result &&
        locationDriver.result.length > 0 &&
        !locationDriver.result[0].endTime &&
        filteredTypeVehicle.length > 0 &&
        driverProfile.result &&
        filteredTypeVehicle ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                {currentVehicle && (
                  <Box
                    style={{
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Typography className={`${classes.Title}`}>
                      คุณกำลังใช้งาน
                    </Typography>
                    <Typography variant="h6">
                      {`${currentVehicle.UseFor} ${currentVehicle.Plate_No}`}
                    </Typography>
                    <Typography>ต้องการสิ้นสุดการใช้งานหรือไม่</Typography>
                    <Avatar
                      className={classes.avatar}
                      src={`${process.env.REACT_APP_URL}image/car/${currentVehicle.imagepath}`}
                      alt={currentVehicle.Plate_No}
                      variant="square"
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <ButtonBlue variant="contained" onClick={onClickYes}>
                ใช่
              </ButtonBlue>
              <ButtonBlue
                variant="contained"
                customColor="#F44336"
                sx={{
                  "&:hover": {
                    borderColor: "#d9392e",
                    backgroundColor: "#d9392e",
                  },
                }}
                onClick={onClose}
              >
                ไม่ใช่
              </ButtonBlue>
            </div>
          </>
        ) : (
          <>
            <div className={`${classes.partOfTitle}`}>
              <div className={`${classes.partOfTitleName}`}>
                <Typography className={`${classes.Title}`}>
                  {driverProfile.result?.serviceType
                    ? "เลือกรถที่ใช้งาน"
                    : "กรุณาเลือกประเภทงานที่กำลังให้บริการ"}
                </Typography>
              </div>
            </div>
            {driverProfile.result?.serviceType && (
              <form onSubmit={handleSubmit(onClickSubmit)}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    {selectedVehicle && (
                      <Box
                        style={{
                          padding: "15px",
                          marginTop: "10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="h6">รายละเอียดรถ</Typography>
                        <Avatar
                          className={classes.avatar}
                          src={`${process.env.REACT_APP_URL}image/car/${selectedVehicle.imagepath}`}
                          alt={selectedVehicle.Plate_No}
                          variant="square"
                        />
                        <Typography>
                          ทะเบียนรถ: {selectedVehicle.Plate_No}
                        </Typography>
                        <Typography>
                          ใช้สำหรับ: {selectedVehicle.UseFor}
                        </Typography>
                        <Typography>
                          ประเภท: {selectedVehicle.vehicleTypeNameTH}
                        </Typography>
                      </Box>
                    )}
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="idVehicle">ทะเบียนรถ</InputLabel>
                      <Controller
                        render={(propsInController) => (
                          <Select
                            labelId="idVehicle"
                            id="idVehicle"
                            value={propsInController.field.value || ""}
                            onChange={(event) => {
                              propsInController.field.onChange(event);
                              handleVehicleChange(event);
                            }}
                            label="ทะเบียนรถ"
                          >
                            {filteredTypeVehicle &&
                              filteredTypeVehicle.map((vehicle) => (
                                <MenuItem
                                  key={vehicle.idVehicle}
                                  value={vehicle.idVehicle}
                                >
                                  {vehicle.Plate_No}
                                </MenuItem>
                              ))}
                          </Select>
                        )}
                        name="idVehicle"
                        control={control}
                        defaultValue={""}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}></Grid>
                </Grid>
                <div className={`${classes.partOfNavButton}`}>
                  <ButtonBlue
                    variant="contained"
                    type="submit"
                    disabled={!selectedVehicleId}
                  >
                    ยืนยันการใช้งาน
                  </ButtonBlue>
                </div>
              </form>
            )}
          </>
        )}
      </Paper>
    </Modal>
  );
};

export default CarConnectionModal;
